import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Prevent execution on old cached previews that Turbo flashes
    if (document.documentElement.hasAttribute('data-turbo-preview')) return

    // Since the script tag is synchronous, turnstile is always present here.
    // .ready() ensures Cloudflare's internal engine is fully active.
    if (window.turnstile) {
      window.turnstile.ready(() => this.renderWidget())
    }
  }

  renderWidget() {
    const widget = this.element.querySelector('.cf-turnstile') || this.element
    if (!widget) return

    // Pull configuration attributes dynamically injected by your Rails gem
    const siteKey = widget.dataset.sitekey || widget.getAttribute('data-sitekey')
    const theme = widget.dataset.theme || widget.getAttribute('data-theme') || 'light'
    const size = widget.dataset.size || widget.getAttribute('data-size') || 'normal'
    const action = widget.dataset.action || widget.getAttribute('data-action')

    if (siteKey) {
      // Clear out the element container to handle clean Turbo Stream state replacements
      widget.innerHTML = ''
      
      // Explicitly trigger the render using the exact attributes defined by Rails
      window.turnstile.render(widget, {
        sitekey: siteKey,
        theme: theme,
        size: size,
        action: action
      })
    }
  }
}
